// functions/lib/ugc/versions.ts
//
// Quelle version l'équipe relit, en un seul endroit pour le serveur et l'admin (la décision envoie
// le numéro de la version vue, `seen.draftVersion`, que le serveur compare au même calcul) :
// - version jointe à une idée : la dernière version reçue que la personne n'a pas retirée, si son
//   fichier existe encore (une version effacée ne se relit plus) ;
// - version relue à l'étape du brouillon : la dernière version prête.

import type { DraftStatus } from '../../../src/lib/ugcTypes'

export type VersionLike = { status: DraftStatus; version: number; withdrawn: boolean }

export function joinedVersionOf<T extends VersionLike>(drafts: readonly T[]): T | null {
  let latest: T | null = null
  for (const d of drafts) {
    if ((d.status !== 'ready' && d.status !== 'purged') || d.withdrawn) continue
    if (latest === null || d.version > latest.version) latest = d
  }
  return latest?.status === 'ready' ? latest : null
}

export function latestReadyOf<T extends Pick<VersionLike, 'status' | 'version'>>(drafts: readonly T[]): T | null {
  let latest: T | null = null
  for (const d of drafts) if (d.status === 'ready' && (latest === null || d.version > latest.version)) latest = d
  return latest
}
